export class AuthService {
  constructor(apiService, authStorageService) {
    this.apiService = apiService;
    this.authStorageService = authStorageService;
    this.initialize();
  }

  initialize() {
    const auth = this.authStorageService.getAuth();
    if (!this.authStorageService.isAuthValid(auth)) {
      this.authStorageService.setAuth(null);
    }
  }

  async signIn({email, password}) {
    const response = await this.apiService.post('/auth', {email: email, password: password});
    this.authStorageService.setAuth(response);
    return response;
  }

  async signOut() {
    this.authStorageService.removeAuth();
  }
}